import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const goToCalculadora = () => {
    setIsOpen(false);
    navigate('/calculadora-roi');
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <nav className="bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b border-border py-3 sticky top-0 z-50">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img
            src="/brand/logo-secundario.svg"
            alt="dgenny"
            className="h-9 w-auto"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('super-agente')}
            className="text-sm font-medium text-brand-azul/80 hover:text-brand-azul transition-colors"
          >
            Super Agente
          </button>
          <button
            onClick={() => scrollToSection('cases')}
            className="text-sm font-medium text-brand-azul/80 hover:text-brand-azul transition-colors"
          >
            Casos
          </button>
          <button
            onClick={goToCalculadora}
            className="text-sm font-medium text-brand-azul/80 hover:text-brand-azul transition-colors"
          >
            Calculadora de ROI
          </button>
        </div>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-brand-azul focus:outline-none focus:ring-2 focus:ring-brand-roxo rounded"
          aria-label="Open menu"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
          </svg>
        </button>

        <div className="hidden md:flex items-center">
          <button
            onClick={goToCalculadora}
            className="bg-brand-roxo hover:bg-brand-roxo/90 text-white font-semibold px-5 py-2.5 rounded-full transition-colors shadow-sm"
          >
            Calcular meu ROI
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-md border-t border-border py-2">
            <button
              onClick={() => scrollToSection('super-agente')}
              className="block w-full text-left px-4 py-3 text-brand-azul hover:bg-muted transition-colors"
            >
              Super Agente
            </button>
            <button
              onClick={() => scrollToSection('cases')}
              className="block w-full text-left px-4 py-3 text-brand-azul hover:bg-muted transition-colors"
            >
              Casos
            </button>
            <div className="px-4 py-3">
              <button
                onClick={goToCalculadora}
                className="w-full bg-brand-roxo hover:bg-brand-roxo/90 text-white font-semibold px-5 py-3 rounded-full transition-colors"
              >
                Calcular meu ROI
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
